export default __webpack_public_path__ + "static/media/savings.7fd1d227.jpg";